import React, {useEffect} from 'react';
import {AuthService} from "../../service/AuthService";
import {useNavigate} from "react-router-dom";

export const Logout = () => {
  const navigate = useNavigate()

  useEffect(() => {
    AuthService.logout();
    navigate('/admin');
  }, [navigate]);

  return (
    <></>
  );
}
